



















import { Bar } from 'vue-chartjs/legacy';
import Vue from 'vue';

import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip, } from 'chart.js';
import { ReportSpec } from '@/components/ReportControls.vue';
import axios from 'axios';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAutorenew } from '@mdi/js';
import { DateTime } from "luxon";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default Vue.extend({
  name: 'BarChart',
  components: {
    Bar,
    SvgIcon,
  },
  props: {
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    width: {
      type: Number,
      default: 480,
    },
    height: {
      type: Number,
      default: 270,
    },
    spec: Object as () => ReportSpec,
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      if (this.spec?.dateStyle == "calendar") {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-pallet-sizes/${depot}/${DateTime.fromJSDate(from).toISODate()}/${DateTime.fromJSDate(to).toISODate()}/`;
      } else {
        const { depot, from, to } = this.spec;
        return `${BASE_URL}/reports/customer-review-pallet-sizes/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/`;
      }
    },
  },
  data() {
    return {
      path: mdiAutorenew,
      size: 48,
      loading: true,
      chartData: {
        labels: [
          'FP',
          'LP',
          'HP',
          'QP',
          'MQP',
          'EPL',
        ],
        datasets: [
          {
            label: '# of Pallets',
            backgroundColor: '#82BD53',
            data: [] as number[],
          },
        ],
      },
      chartOptions: {
        resizeDelay: 2,
        responsive: false,
        maintainAspectRatio: false,
        layout: {
          padding: 5,
        },
        plugins: {
          title: {
            display: true,
            text: 'Pallet Sizes',
            padding: {
              top: 5,
              bottom: 1,
            },
            font: {
              size: 16,
            },
          },
          datalabels: {
            display: false,
          },
          legend: {
            display: true,
            labels: {
              boxWidth: 12,
              font: {
                size: 14,
              },
            },
          },
        },
      },
    };
  },
  watch: {
    spec: {
      immediate: true,
      async handler() {
        const response = await axios.get<{ [size: string]: number }>(this.dataUrl, {
          params: {
            account_codes: this.spec.accountCodes.flatMap((a) => a.codes),
          },
        });
        this.chartData.datasets[0].data = this.chartData.labels.map((size) => response.data[size] ?? 0);
        this.loading = false;
      },
    },
  },
});
